import { axios } from '@/services/axios';

const getRegionByID = (regionId) => {
    return axios.get(`/region/${regionId}`);
};

export default getRegionByID;
